import { getVariantItemImageUrl } from './get-product-image-url.js';

const groupByFacetKey = (variants, facetConfig)=>{
    const grouped = new Map();
    for (const variant of variants){
        const key = variant.facets[facetConfig.facetKey] || null;
        const variantGroup = grouped.get(key) || [];
        variantGroup.push(variant);
        grouped.set(key, variantGroup);
    }
    return grouped;
};
/**
 * This function recursively loops through the facetConfigList and groups a list of variants by facet key.
 * If a variant has no facetTerm value for a given key, it will be grouped under `facetKey: null`
 */ const buildTree = (facetConfigList, variants, facetConfigIndex)=>{
    if (facetConfigIndex >= facetConfigList.length) return [];
    const currentFacetConfig = facetConfigList[facetConfigIndex];
    if (!currentFacetConfig) return [];
    const groupedVariants = groupByFacetKey(variants, currentFacetConfig);
    return Array.from(groupedVariants, ([facetTerm, variantGroup])=>{
        const firstVariant = variantGroup[0];
        if (!firstVariant) {
            throw new Error(`Something went wrong while building the variant facet tree for facetTerm: ${facetTerm}`);
        }
        const { sku , slug , displayName , media  } = firstVariant;
        const skuCollection = variantGroup.map((v)=>v.sku
        );
        const childFacets = buildTree(facetConfigList, variantGroup, facetConfigIndex + 1);
        return {
            facetKey: currentFacetConfig.facetKey,
            facetTerm,
            childFacets,
            name: displayName,
            imageUrl: getVariantItemImageUrl(media),
            skuCollection,
            sku,
            slug
        };
    });
};
const createVariantSelectorTree = (variants, facetConfigList)=>{
    if (!facetConfigList.length) return [];
    const publishedVariants = variants.filter((variant)=>variant.isPublished
    );
    return buildTree(facetConfigList, publishedVariants, 0);
};

export { createVariantSelectorTree };
//# sourceMappingURL=create-variant-facet-tree.js.map
